import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import ExtensionAutoConnect from './components/extension/ExtensionAutoConnect';
import AppRoutes from './routes/AppRoutes';
import { ROUTER_BASENAME } from './config/routerBasename';
import { queryClient } from './lib/queryClient';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ExtensionAutoConnect />
        <Router basename={ROUTER_BASENAME}>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
